/* eslint-disable no-barrel-files/no-barrel-files */
/**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */

export type {
	CreateCompanyHubSpaceMutation$data as CreateCompanyHubSpaceMutation,
	CreateCompanyHubSpaceMutation$variables as CreateCompanyHubSpaceMutationVariables,
} from '../__generated__/CreateCompanyHubSpaceMutation.graphql.ts';

// Nested types extracted from Relay-generated types
import type { CreateCompanyHubSpaceMutation$data } from '../__generated__/CreateCompanyHubSpaceMutation.graphql.ts';
export type CreateCompanyHubSpaceMutation_createSystemSpace = NonNullable<CreateCompanyHubSpaceMutation$data['createSystemSpace']>;

// GraphQL input types re-exported from Relay artifact
export type { SystemSpaceHomepageInput } from '../__generated__/CreateCompanyHubSpaceMutation.graphql.ts';

// GraphQL enums (preserved from original file)
// ⚠️  DEPRECATION WARNING: Prefer using Relay's generated union string types instead of enums.
// Relay generates more type-safe union types (e.g., "DRAFT" | "PUBLISHED" | "ARCHIVED")
// instead of enums. These enums are kept for backward compatibility only.
export enum SystemSpaceHomepageTemplate {
  EAP = "EAP",
  MINIMAL = "MINIMAL",
  VISUAL = "VISUAL",
}

